// Presentation only: explicit zero/codes occupy a date; derived Дт does not.
function calendarDay(date) {
    const weekday = new Date(`${date}T12:00:00Z`).getUTCDay();
    return {weekend: weekday === 0 || weekday === 6, weekday: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'][weekday]};
}

function internalGaps(dates, explicitDates, complete = true) {
    const result = new Map();
    if (!complete) return result;
    const occupied = new Set(explicitDates), filled = dates.filter(date => occupied.has(date));
    if (filled.length < 2) return result;
    let range = [];
    const flush = () => {
        if (!range.length) return;
        const gap = {first: range[0], last: range[range.length - 1]};
        range.forEach(date => result.set(date, gap));
        range = [];
    };
    dates.forEach(date => {
        if (date > filled[0] && date < filled[filled.length - 1] && !occupied.has(date)) range.push(date);
        else flush();
    });
    flush();
    return result;
}

const dateLabel = date => new Date(`${date}T12:00:00Z`).toLocaleDateString('ru-RU', {day: 'numeric', month: 'long', timeZone: 'UTC'});
function gapHint(gap, date, scope) {
    if (!gap) return '';
    const range = gap.first === gap.last ? dateLabel(gap.first) : `${dateLabel(gap.first)} — ${dateLabel(gap.last)}`;
    return `Нет отметок ${range} между заполненными днями. ${scope}.`
        + (calendarDay(date).weekend ? ' Проверьте, нужна ли отметка «В» или другая отметка.' : '');
}

module.exports = {calendarDay, internalGaps, gapHint};
